import React, { useState } from "react";
import "./About.css";

export default function About() {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className="book-wrapper">

      <div className={`book ${flipped ? "flipped" : ""}`}>

        {/* PAGE 1 - ABOUT + MISSION (COMBINED) */}
        <div className="page front-page">
          <div className="page-content">

            <h1>About Our School</h1>

            <p>
              We are a Primary and Middle School focusing on strengthening
              fundamentals so students clearly understand core concepts.
              We also emphasize value-based education to build both academic
              excellence and strong character in every child.
            </p>

            <h2>Our Mission</h2>

            <p>
              Our mission is to focus on concept-based teaching that helps
              students understand subjects deeply and clearly. We aim to
              nurture disciplined, confident learners through value-based
              education and holistic development.
            </p>

            <button onClick={() => setFlipped(true)}>
              Next Page →
            </button>

          </div>
        </div>

        {/* PAGE 2 - CONTACT + MAP (YOUR EXACT MAP DIV) */}
        <div className="page back-page">
          <div className="page-content">

            <h2>Contact Us</h2>

            <p>
              Phone: +91-6305632132, +91-8096997062
            </p>

            {/* YOUR EXACT MAP DIV (UNCHANGED) */}
            <div className="about-right"> <div className="map-box"> <iframe title="school-location" className="map-frame" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3842.2619279344294!2d77.288898874678!3d15.631034484986733!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb64e7715dcfd8b%3A0xffa973d013601162!2sSandeepani%20vidyalaya!5e0!3m2!1sen!2sin!4v1778137927698!5m2!1sen!2sin" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" /> </div> </div>

            <button onClick={() => setFlipped(false)}>
              ← Previous Page
            </button>

          </div>
        </div>

      </div>
    </div>
  );
}